var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-me_grey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "me_grey",
    clipPath: "url(#clip-me_grey)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17330",
    "data-name": "Path 17330",
    d: "M10.6,8.025A6.183,6.183,0,0,0,8.237,6.546a3.588,3.588,0,1,0-4.061,0A6.217,6.217,0,0,0,0,12.414H.97a5.237,5.237,0,1,1,10.474,0h.97A6.167,6.167,0,0,0,10.6,8.025ZM6.207,6.207A2.619,2.619,0,1,1,8.826,3.588,2.622,2.622,0,0,1,6.207,6.207Z",
    transform: "translate(1.582 1.582)",
    fill: "#34495e",
    stroke: "#34495e",
    strokeWidth: 0.5,
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeGrey);
export default __webpack_public_path__ + "static/media/me_grey.71ddbfa66b6bc00b6fdc33aa15614aea.svg";
export { ForwardRef as ReactComponent };